<template lang="jade">
  a.Tile(v-if="isLink"
         ":href"="fdata.url" 
         ":title"="fdata.title")
    div.Tile__background
      div.Tile__pentagon2
    div.Tile__pentagon1
    div.Tile__body
      div.Tile__icon(":title"="fdata.title")
      div.Tile__title {{ fdata.title }}  
  div.Tile(v-else
           @click="click(fdata.actions)"
           ":title"="fdata.title")
    div.Tile__background
      div.Tile__pentagon2
    div.Tile__pentagon1
    div.Tile__body
      div.Tile__icon(":title"="fdata.title")
      div.Tile__title {{ fdata.title }}    
</template>

<script>
  import buttons from '../_shared/traits'
  import { addDynamicWorkflow, addNotification, addWorkflow } from 'src/vuex/actions'

  export default {
    data () {
      return {
        uid: this.$parent.uid
      }
    },
    mixins: [buttons],
    vuex: {
      actions: {
        dynamicWorkflow: addDynamicWorkflow,
        notice: addNotification,
        addWorkflow
      }
    },
    computed: {
      isLink () {
        return _.has(this.fdata, 'url')
      }
    },
    methods: {
      /**
       * What the button should do based on the action stored in VUEX
       */
      click (action) {
        this.$dispatch('replace::workflow',
                       this.fdata.workflowId,
                       this.uid,
                       {button: this.fdata.buttonId})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// tile.vue?6cc9b4c0